import { render, staticRenderFns } from "./VContractProjectForm.vue?vue&type=template&id=7adb220d&"
import script from "./VContractProjectForm.vue?vue&type=script&lang=js&"
export * from "./VContractProjectForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports